import React, {useMemo, useState} from "react";
import "../../styles/style.css";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

// status: 1 available, 2 booked/unavailable, 3 unavailable, 0 no price
const STATUS_COLORS = {
    0: "#95a5a6",
    1: "#1abc9c",
    2: "#e74c3c",
    3: "#e74c3c",
};

const getStatusColor = (status) => {
    const key = Number(status);
    return Object.prototype.hasOwnProperty.call(STATUS_COLORS, key)
        ? STATUS_COLORS[key]
        : STATUS_COLORS[3];
};

const Calendar = (props) => {

    const {events} = props;
    const today = new Date();

    const [startYear, setStartYear] = useState(today.getFullYear());
    const [startMonth, setStartMonth] = useState(today.getMonth());

    const coloredEvents = useMemo(() => {
        return (events || []).map((event) => {
            if (event.status === undefined || event.status === null) {
                return event;
            }
            return {
                ...event,
                backgroundColor: getStatusColor(event.status),
            };
        });
    }, [events]);

    const generateMonths = (startYear, startMonth) => {
        const months = [];

        for (let i = 0; i < 12; i++) {
            const date = new Date(startYear, startMonth + i);
            months.push({
                year: date.getFullYear(),
                month: date.getMonth(),
            });
        }

        return months;
    };
    const monthsToRender = generateMonths(startYear, startMonth);

    const handleNext = () => {
        const newDate = new Date(startYear, startMonth + 12);
        setStartYear(newDate.getFullYear());
        setStartMonth(newDate.getMonth());
    };

    const handlePrev = () => {
        const newDate = new Date(startYear, startMonth - 12);
        setStartYear(newDate.getFullYear());
        setStartMonth(newDate.getMonth());
    };

    let currentMonthRendered = false;

    return (
        <div className="calendar-container">
            <div className="legend">
                <span className="available-box"></span> Available
                <span className="unavailable-box"></span> Unavailable
                <span className="no-price-box"></span> No Price
                <span className="changeover-box"></span> Changeover Day
            </div>

            <div className={`calendar-nav ${startYear > new Date().getFullYear() ? 'both-buttons' : 'only-next'}`}>
                {startYear > new Date().getFullYear() && (
                    <button className="prev-year-btn" onClick={handlePrev}>← Previous Year</button>
                )}

                <button className="next-year-btn" onClick={handleNext}>Next Year →</button>
            </div>

            <div className="calendar-grid">

                {monthsToRender.map(({ year, month }) => {
                    const isCurrentMonth = year === today.getFullYear() && month === today.getMonth();

                    if (isCurrentMonth && currentMonthRendered) return null;
                    if (isCurrentMonth) currentMonthRendered = true;

                    const firstDay = new Date(year, month, 1).toISOString().split("T")[0];

                    return (
                        <div key={`${year}-${month}`} className="calendar-box">
                            <h3>
                                {
                                    new Date(year, month - 1).toLocaleString("default", {
                                        month: "long",
                                        year: "numeric",
                                    })
                                }
                            </h3>
                            <FullCalendar
                                plugins={[dayGridPlugin]}
                                initialView="dayGridMonth"
                                initialDate={isCurrentMonth ? new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split("T")[0] : firstDay}
                                events={coloredEvents}
                                headerToolbar={false}
                                height="auto"
                                eventDisplay="background"
                                dayMaxEventRows={false}
                                fixedWeekCount={false}
                                showNonCurrentDates={false}
                                eventDidMount={(info) => {
                                    const el = info.el;
                                    if (info.event.extendedProps.startHalf === 1) {
                                        const date = info.event.startStr;
                                        const startCell = document.querySelector(`.fc-daygrid-day[data-date="${date}"] .fc-daygrid-day-frame`);
                                        if (startCell) {
                                            startCell.classList.add('start-half-day');
                                        }
                                    }

                                    if (info.event.extendedProps.endHalf === 1) {
                                        let date = info.event.endStr;
                                        if (date) {

                                            const dt = new Date(date);
                                            dt.setDate(dt.getDate() - 1);
                                            const fixedDate = dt.toISOString().split("T")[0];
                                            const endCell = document.querySelector(`.fc-daygrid-day[data-date="${fixedDate}"] .fc-daygrid-day-frame`);
                                            if (endCell) {
                                                endCell.classList.add('end-half-day');
                                            }
                                        }
                                    }
                                }}
                            />

                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default Calendar;

